/**
 * Traducciones del PANEL de quien usa el sistema: el resumen del socio,
 * Mi negocio (tienda, red, órdenes, comisiones), el perfil y los recursos.
 *
 * NO es el panel de administración: eso lo usa la casa, en español.
 *
 * La CLAVE es el texto en español; el valor, su inglés. `{{algo}}` es una
 * interpolación y tiene que aparecer IGUAL en el inglés, o el dato
 * desaparece de la frase.
 */
export const panelEn: Record<string, string> = {
  "A esta cuenta se pagan tus comisiones. El pago requiere tu KYC aprobado.": "This is where your commissions are paid. Payment requires an approved ID check.",
  "A esta cuenta se pagan tus comisiones.": "This is where your commissions are paid.",
  "Tu cuenta es de Estados Unidos: no necesitas subir documentos.": "Your account is in the United States: you don't need to upload any documents.",
  "Abrir la rama": "Open branch",
  "Acción": "Action",
  "Activar mi código": "Activate my code",
  "Activar mi red": "Activate my network",
  "Adquiere tu franquicia.": "Get your franchise.",
  "Al registrarlo, la venta se valida y el stock se descuenta de tu vitrina.": "Once recorded, the sale is verified and the stock comes off your storefront.",
  "Anuncio": "Announcement",
  "Apagada": "Off",
  "Apellidos": "Last name",
  "Aquí aparece solo lo que tus paquetes te han surtido: tu tienda vende lo que compraste. Apaga lo que no quieras vender, y deja el precio vacío para usar el de socio del catálogo.": "Only what your packages stocked you with shows up here: your store sells what you bought. Turn off anything you'd rather not sell, and leave the price empty to use the catalog's partner price.",
  "Artículos": "Items",
  "Así se ve en tu tienda": "This is how it looks in your store",
  "Añadir a mi tienda": "Add to my store",
  "Base": "Base",
  "Bienestar que se nota": "Wellness you can see",
  "Bienestar que se nota, de mi familia a la tuya.": "Wellness you can see, from my family to yours.",
  "Bienvenida": "Welcome message",
  "Bono": "Bonus",
  "Borrar": "Delete",
  "Borrar {{dir}}": "Delete {{dir}}",
  "Buscar mi dirección": "Search for my address",
  "Buscar recursos": "Search resources",
  "Buscar…": "Search…",
  "CLABE (18 dígitos)": "CLABE (18 digits, Mexico)",
  "País de la cuenta": "Account country",
  "México (CLABE)": "Mexico (CLABE)",
  "Estados Unidos (ACH)": "United States (ACH)",
  "Routing number (9 dígitos)": "Routing number (9 digits)",
  "Cada pedido hecho en tu tienda personalizada aparecerá aquí.": "Every order placed in your own store will appear here.",
  "Cambiar": "Change",
  "Cambiar contraseña": "Change password",
  "Cargando su actividad…": "Loading their activity…",
  "Cargando tu línea…": "Loading your line…",
  "Cargando…": "Loading…",
  "Cliente": "Customer",
  "Color de tu marca": "Your brand color",
  "Color {{hex}}": "Color {{hex}}",
  "Comisión": "Commission",
  "Como aparece en el banco": "As it appears at the bank",
  "Comparte tu enlace de invitación: quien se registre con él aparecerá aquí.": "Share your invite link: anyone who signs up with it shows up here.",
  "Comparte tu enlace: quien se registre con él aparece aquí.": "Share your link: anyone who signs up with it shows up here.",
  "Comparte tu tienda": "Share your store",
  "Compartir": "Share",
  "Compartir por WhatsApp": "Share on WhatsApp",
  "Compra de paquetes": "Package purchase",
  "Comprobante del pago (recomendado)": "Payment receipt (recommended)",
  "Con inventario, aquí eliges cuáles se lucen.": "Once you have inventory, this is where you pick which ones stand out.",
  "Con número, tu tienda enseña un botón de “Escríbeme”.": "With a number, your store shows a “Message me” button.",
  "Con precio propio": "With your own price",
  "Configurar": "Set up",
  "Confirmas que {{name}} ya te pagó": "You're confirming that {{name}} has paid you",
  "Confírmala": "Confirm it",
  "Conocer la franquicia": "Learn about the franchise",
  "Contraseña actual": "Current password",
  "Contraseña cambiada. Úsala en tu siguiente inicio de sesión.": "Password changed. Use it next time you sign in.",
  "Copiado": "Copied",
  "Copiar": "Copy",
  "Copiar enlace": "Copy link",
  "Copiar mi correo": "Copy my email",
  "Crear mi cuenta de todas formas": "Create my account anyway",
  "Cuando alguien de tu red compre y su pago se valide, tu bono aparece aquí con su cuenta.": "When someone in your network buys and their payment is verified, your bonus shows up here with the math.",
  "Cuando la casa publique formación, la encuentras aquí.": "When the company publishes training, you'll find it here.",
  "Cuando tus invitados compren, tus bonos aparecen aquí.": "When your invitees buy, your bonuses appear here.",
  "Código QR de tu enlace": "QR code for your link",
  "Dashboard": "Dashboard",
  "Decide tu idioma y la moneda en la que se te cobra": "Sets your language and the currency you're charged in",
  "Descargar": "Download",
  "Descargar Excel": "Download Excel",
  "Descargar QR": "Download QR",
  "Directos": "Direct",
  "Editar {{dir}}": "Edit {{dir}}",
  "El comprobante no puede pasar de 4 MB.": "The receipt can't be larger than 4 MB.",
  "El documento no puede pasar de 4 MB.": "The document can't be larger than 4 MB.",
  "Elegir otro color": "Pick another color",
  "Elige tu país": "Choose your country",
  "En tu red": "In your network",
  "En tu tienda": "In your store",
  "Escanéame": "Scan me",
  "Escribe calle y número…": "Type street and number…",
  "Escríbeme": "Message me",
  "Ese código no corresponde a nadie. Revísalo con quien te invitó.": "That code doesn't match anyone. Check it with whoever invited you.",
  "Ese enlace no funciona": "That link doesn't work",
  "Este es el enlace para tus clientes: quien entre ve tus productos a tus precios.": "This is the link for your customers: whoever opens it sees your products at your prices.",
  "Experiencia de tu tienda": "Your store experience",
  "Fecha": "Date",
  "Folio": "Order no.",
  "Fondo de la portada": "Cover background",
  "Fondo del banner": "Banner background",
  "Fondo {{name}}": "{{name}} background",
  "Formación y materiales para hacer crecer tu negocio.": "Training and materials to grow your business.",
  "Foto o PDF, hasta 4 MB.": "Photo or PDF, up to 4 MB.",
  "Franquiciataria": "Franchisee",
  "Franquiciataria desde": "Franchisee since",
  "Franquiciataria desde el {{fecha}}.": "Franchisee since {{fecha}}.",
  "Guarda tu enlace para compartirlo": "Save your link to share it",
  "Guardado": "Saved",
  "Guardado. Tus comisiones se pagarán a esta cuenta.": "Saved. Your commissions will be paid to this account.",
  "Guardar método de pago": "Save payment method",
  "Hola, {{name}}. Así va tu cuenta.": "Hi, {{name}}. Here's how your account is doing.",
  "Identidad de tu tienda": "Your store identity",
  "Invitar por WhatsApp": "Invite on WhatsApp",
  "La verificación de identidad. Será requisito para el pago de comisiones.": "Identity verification. It will be required before commissions are paid.",
  "Las contraseñas no coinciden": "The passwords don't match",
  "Liberado": "Released",
  "Lo que tu red te ha generado, con la cuenta de cada bono.": "What your network has earned you, with the math behind each bonus.",
  "Lo que vende tu tienda": "What your store sells",
  "Mensaje del banner": "Banner message",
  "Mi enlace de invitación": "My invite link",
  "Mi perfil": "My profile",
  "Mi red": "My network",
  "Mi tienda": "My store",
  "Mis comisiones": "My commissions",
  "Mis compras": "My purchases",
  "Mis pedidos": "My orders",
  "Mis puntos (PV)": "My points (PV)",
  "Mis órdenes": "My orders",
  "Monto": "Amount",
  "Mostrar compra de paquetes en mi tienda": "Show package purchases in my store",
  "Mostrar en grande": "Show large",
  "Nada coincide con ese filtro.": "Nothing matches that filter.",
  "Negocio digital (mayorista)": "Digital business (wholesale)",
  "Nivel": "Level",
  "Nivel {{n}}": "Level {{n}}",
  "Nivel {{n}} ({{c}})": "Level {{n}} ({{c}})",
  "Niveles activos": "Active levels",
  "No generó": "Earned nothing",
  "No se pudo activar tu código. Inténtalo otra vez.": "We couldn't activate your code. Please try again.",
  "No se pudo cambiar": "We couldn't change it",
  "No se pudo guardar": "We couldn't save it",
  "No se pudo guardar. Inténtalo otra vez.": "We couldn't save it. Please try again.",
  "No se pudo registrar el pago": "We couldn't record the payment",
  "No se pudo subir el documento": "We couldn't upload the document",
  "Nombre de tu tienda": "Your store name",
  "Nombre o código…": "Name or code…",
  "Nueva contraseña": "New password",
  "Pagado": "Paid",
  "País": "Country",
  "Pedidos recientes": "Recent orders",
  "Piezas en stock": "Units in stock",
  "Piezas que publicas de {{name}}": "Units you publish of {{name}}",
  "Pinta tu vitrina entera: el nombre en la portada, los precios, los botones de comprar y el de WhatsApp.": "Colors your whole storefront: the name on the cover, the prices, the buy buttons and the WhatsApp one.",
  "Plegar la rama": "Collapse branch",
  "Por liberar": "To be released",
  "Portada {{name}}": "{{name}} cover",
  "Portón negro, entre Reforma y Juárez": "Black gate, between Reforma and Juárez",
  "Precio de catálogo": "Catalog price",
  "Productos que flotan en tu portada (hasta 3)": "Products featured on your cover (up to 3)",
  "Productos y precios": "Products and prices",
  "Publicas": "You publish",
  "Puedes cambiarlo UNA sola vez. Elígelo con calma: después queda fijo para que tus clientes nunca lleguen a rutas muertas.": "You can change it ONCE. Take your time: after that it's fixed, so your customers never land on a dead link.",
  "Quitar de mi tienda": "Remove from my store",
  "Qué compró": "What they bought",
  "Qué corregir: {{nota}}": "What to fix: {{nota}}",
  "Recibimos tus documentos. Te avisamos al revisarlos.": "We got your documents. We'll let you know once we've reviewed them.",
  "Recursos": "Resources",
  "Reemplazar": "Replace",
  "Referencia (opcional)": "Landmark (optional)",
  "Registrar el pago": "Record the payment",
  "Activo este mes · cobras comisiones": "Active this month · you earn commissions",
  "Sin recompra este mes · te faltan {{n}} PV para cobrar": "No repurchase this month · {{n}} PV short of earning",
  "{{pv}} de {{req}} PV en los últimos {{days}} días": "{{pv}} of {{req}} PV in the last {{days}} days",
  "PV al mes para ser socio activo": "Monthly PV to be an active member",
  "Los puntos para ser socio activo son un entero, 0 o más": "Points to be an active member must be a whole number, 0 or more",
  "Quien no junta esos puntos con sus propias compras dentro del ciclo es cliente ese mes: paga precio de socio, pero no cobra comisiones de su red. Aplica igual al franquiciatario.":
    "Whoever does not reach those points with their own purchases within the cycle is a customer that month: pays the member price but earns no network commissions. Same for franchisees.",
  "Pagar todo ({{currency}})": "Pay everything ({{currency}})",
  "Se marcarán como PAGADAS todas las comisiones debidas en {{currency}}, por un total de":
    "Every commission owed in {{currency}} will be marked as PAID, for a total of",
  "Registrar el pago de {{folio}}": "Record payment for {{folio}}",
  "Registrar pago": "Record payment",
  "Resultados": "Results",
  "Resumen": "Overview",
  "Revisa la contraseña nueva": "Check the new password",
  "Revisa los datos": "Check the details",
  "Revisa los datos bancarios": "Check the bank details",
  "Seguridad": "Security",
  "Si habilitas la compra de paquetes ganas los bonos del plan de referidos de It's The Best, no del sobreprecio de ningún paquete.": "If you enable package purchases you earn the bonuses from the It's The Best referral plan, not a markup on any package.",
  "Sin elegir, la portada usa los primeros de tu vitrina.": "If you pick none, the cover uses the first ones in your storefront.",
  "Sin productos que vender": "No products to sell",
  "Socio": "Partner",
  "Socio desde": "Partner since",
  "Solo se aceptan fotos (JPG, PNG, WebP) o PDF.": "Only photos (JPG, PNG, WebP) or PDF are accepted.",
  "Subir": "Upload",
  "Te comparto mi tienda de It's The Best:": "Here's my It's The Best store:",
  "Te comparto mi tienda de It's The Best: {{url}}": "Here's my It's The Best store: {{url}}",
  "Te falta el teléfono. Es a donde te llamamos si tu pedido tiene un problema.": "Your phone number is missing. It's how we reach you if there's a problem with your order.",
  "Todavía no ha comprado nada. Cuando lo haga, aquí verás qué te genera.": "They haven't bought anything yet. When they do, you'll see what it earns you here.",
  "Todavía no has comprado": "You haven't bought anything yet",
  "Todavía no hay invitados": "No invitees yet",
  "Todavía no hay materiales": "No materials yet",
  "Todavía no hay ventas": "No sales yet",
  "Todavía no tienes pedidos. Tu primera compra validada te vuelve socio.": "You don't have any orders yet. Your first verified purchase makes you a partner.",
  "Todavía no tienes posición en la red. Actívala y comparte tu enlace: cada compra de tus invitados te genera bonos.": "You don't have a position in the network yet. Activate it and share your link: every purchase your invitees make earns you bonuses.",
  "Todavía sin comisiones": "No commissions yet",
  "Todos los tipos": "All types",
  "Tu comisión": "Your commission",
  "Tu cuenta todavía no está en la red. Activa tu código para empezar a invitar.": "Your account isn't in the network yet. Activate your code to start inviting.",
  "Tu enlace": "Your link",
  "Tu enlace de invitación": "Your invite link",
  "Tu enlace de invitación y la gente de tu línea, rama por rama.": "Your invite link and the people in your line, branch by branch.",
  "Tu enlace ya quedó fijo: se personaliza una sola vez.": "Your link is now fixed: it can only be customized once.",
  "Tu inventario sale de tus paquetes mayoristas. Adquiere uno para llenar tu tienda.": "Your inventory comes from your wholesale packages. Get one to fill your store.",
  "Tu inventario sale de tus paquetes mayoristas: sin paquete no hay producto que vender. Adquiere uno para llenar tu tienda.": "Your inventory comes from your wholesale packages: no package means nothing to sell. Get one to fill your store.",
  "Tu mensaje del banner aquí": "Your banner message here",
  "Tu número local. Le ponemos la lada de {{pais}}.": "Your local number. We'll add the {{pais}} country code.",
  "Tu precio": "Your price",
  "Tu precio de {{name}}": "Your price for {{name}}",
  "Tu próxima presentación o cualquier aviso para quien entre.": "Your next event, or any notice for whoever visits.",
  "Tu red": "Your network",
  "Tu red ({{n}})": "Your network ({{n}})",
  "Tu tienda": "Your store",
  "Tu tienda propia dentro de la plataforma, precios de mayorista y los bonos de franquicia del plan.": "Your own store inside the platform, wholesale prices, and the plan's franchise bonuses.",
  "Tu tienda quedó guardada.": "Your store has been saved.",
  "Tu tienda se abre en la sección Mi tienda.": "Your store opens in the My store section.",
  "Tus compras en It's The Best.": "Your It's The Best purchases.",
  "Tus compras y las ventas de tu tienda.": "Your purchases and your store's sales.",
  "Tus datos, a dónde te pagamos y tu contraseña.": "Your details, where we pay you, and your password.",
  "Tus invitados": "Your invitees",
  "Tus pedidos en It's The Best aparecerán aquí.": "Your It's The Best orders will appear here.",
  "Tus productos": "Your products",
  "Tú decides qué productos aparecen, a qué precio, y cómo se ve tu tienda.": "You decide which products appear, at what price, and how your store looks.",
  "Usar {{dir}} por defecto": "Use {{dir}} by default",
  "Ventas": "Sales",
  "Ventas de mi tienda": "My store's sales",
  "Ventas recientes": "Recent sales",
  "Ver el QR en grande": "View the QR large",
  "Ver la red": "View the network",
  "Ver lo que ha comprado {{nombre}}": "See what {{nombre}} has bought",
  "Ver mi tienda": "View my store",
  "Ver todas": "View all",
  "Ver todo": "View all",
  "Verificación de identidad": "Identity verification",
  "Verificando tu invitación…": "Checking your invitation…",
  "Visible": "Visible",
  "WhatsApp de contacto": "Contact WhatsApp",
  "canvas": "canvas",
  "de {{n}}": "of {{n}}",
  "de {{n}} en tu inventario": "of {{n}} in your inventory",
  "hasta 8 niveles": "up to 8 levels",
  "productos a la venta": "products for sale",
  "subido el {{fecha}}": "uploaded {{fecha}}",
  "unidades de tus paquetes": "units from your packages",
  "{{cv}} CV · {{n}} compras": "{{cv}} CV · {{n}} purchases",
  "{{estado}}: {{name}}": "{{estado}}: {{name}}",
  "{{n}} de {{m}} visibles": "{{n}} of {{m}} visible",
  "{{n}} en stock": "{{n}} in stock",
  "Únete a mi equipo en It's The Best:": "Join my team at It's The Best:",
  "Únete a mi equipo en It's The Best: {{url}}": "Join my team at It's The Best: {{url}}",
  "Con tu código activo, aquí verás a quien entre por tu enlace.": "With your code active, you'll see everyone who joins through your link here.",
};
